<template>
    <div class="employee-show">
      <Header ></Header>
      <Details :employeeDetails="employeeDetails"></Details>
      <Certifications :certifications="employeeDetails.certifications"></Certifications>
      <Trainings :trainings="this.employeeDetails.training_programs"></Trainings>
      <Footer></Footer>
    </div>
  </template>

  <script>
  import Certifications from '@/components/Employee/Certifications.vue';
  import Details from '@/components/Employee/Details.vue';
  import Header from '@/components/Employee/Header.vue';
  import Footer from '@/components/Home/Footer.vue';
  import Trainings from '@/components/Employee/Trainings.vue';
  import axios from 'axios';

  export default {
    name: 'EmployeeShow',
    components: { Header, Details, Certifications, Trainings, Footer },
    data() {
      return {
        employeeDetails: null,
      };
    },
    created() {
      this.fetchEmployeeDetails();
    },
    methods: {
      async fetchEmployeeDetails() {
        try {
          const response = await axios.get(`ministries/employees/${this.$route.params.id}`);
          this.employeeDetails = response.data.data.employee;
          console.log(this.employeeDetails.training_programs)
        } catch (error) {
          console.error('Error fetching employee details:', error);
        }
      },
    },
  };
  </script>

  <style lang="">
  </style>
